<form [formGroup]="formFilter">
  <div class="table-buttons">
    @if(mostrarFiltro){
    <div class="filtros">


      @if (this.filtros.length > 0) {
      <select id="filter-field" formControlName="filterField">
        <option disabled selected>Selecione</option>
        @for (item of this.filtros; track item.value) {
        <option value="{{item.value}}">{{item.label}}</option>
        }

      </select>
      }@else if (this.tipoRelatorio == 0) {
      <!--Painel Geral -->
      <select id="filter-field" formControlName="filterField">
        <option></option>
        <option value="codigoChamado">Chamado</option>
        <option value="nomeGravidade">Gravidade</option>
        <option value="nomeCategoria">Categoria</option>
        <option value="nomeSubCategoria">Subcategoria</option>
        <option value="dsStatus">Status</option>
        <option value="nomeEscola">Escola</option>
      </select>
      }@else if(this.tipoRelatorio == 1) {
      <!--Painel Avaliação Fiscal -->
      <select id="filter-field" formControlName="filterField">
        <option></option>
        <option value="codigoAtividadePsicologo">Código</option>
        <option value="nomeDiretoria">URE</option>
        <option value="nomeEscola">Escola</option>
        <option value="deslocamentoEscolaOrigem">Escola Origem</option>
        <option value="nomePsicologo">Psicólogo</option>
        <option value="descricaoTipoAcao">Tipo Ação</option>
        <option value="ocorrenciaAgendada">Ocorrencia</option>
        <option value="descricaoAtividadeRealizada">Tipo Ação</option>
        <option value="descricaoValidacaoFiscal">Validação Fiscal</option>
      </select>
      }@else if(this.tipoRelatorio == 2) {
      <!--Painel Avaliação Fiscal -->
      <select id="filter-field" formControlName="filterField">
        <option></option>
        <option value="codigoChamado">Nº Chamado</option>
        <option value="nomeEnvolvido">Nome Envolvido</option>
        <option value="tipoEnvolvimento">Tipo Envolvido</option>
        <option value="escola">Escola</option>
        <option value="psicologo">Psicólogo</option>
      </select>
      }@else if(this.tipoRelatorio == 3) {
      <select id="filter-field" formControlName="filterField">
        <option></option>
        <option value="nomeDiretoria">URE</option>
        <option value="nomeEscola">Unidade Escolar</option>
      </select>
      }
      <select id="filter-type" formControlName="filterType">
        <option value="=">=</option>
        <option value="<">
          << /option>
        <option value="<=">
          <=< /option>
        <option value=">">></option>
        <option value=">=">>=</option>
        <option value="!=">!=</option>
        <option value="like">like</option>
      </select>

      <input id="filter-value" type="text" formControlName="filterValue" (keyup)="filtarValue()" />

      <button id="filter-clear" (click)="clearFilters()">Limpar filtro</button>
    </div>
    }

    <div class="buttons">
      @if(mostrarImprimir){
      <button type="button" class="btn-header impressao" (click)="ImprimirTabela()">
        Imprimir
      </button>
      }

      @if(mostrarExportarHtml){
      <button type="button" class="btn-header impressao" (click)="ExportarHTML()">
        Html
      </button>
      }

      @if(mostrarExportarExcel){
      <button type="button" class="btn-header excel" (click)="ExportComoExcel()">
        Excel
      </button>
      }

      @if(mostrarExportarPDF){
      <button type="button" class="btn-header pdf" (click)="ExportarComoPDF()">
        PDF
      </button>
      }
    </div>

    @if(legendaHtml){
    <div class="legenda-container" [innerHTML]="legendaHtml"></div>
    }
  </div>
</form>



<div #tableHolder></div>